import { provideHttpClient, withFetch } from "@angular/common/http";
import type { ApplicationConfig } from "@angular/core";
import { provideExperimentalZonelessChangeDetection } from "@angular/core";
import {
  provideClientHydration,
  withIncrementalHydration,
} from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, withInMemoryScrolling } from "@angular/router";
import { providePrimeNG } from "primeng/config";
import { appRoutes } from "./app.routes";

import { PrimeCustomPreset } from "@optee/config/primeng.preset";

export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideClientHydration(withIncrementalHydration()),
    provideHttpClient(withFetch()),
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        scrollPositionRestoration: "enabled",
      }),
    ),
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: PrimeCustomPreset,
        options: {
          darkModeSelector: false,
          cssLayer: {
            name: "primeng",
            order: "tailwind-base, primeng, tailwind-utilities, override-css",
          },
        },
      },
    }),
  ],
};
